
class SwiperContainer extends HTMLElement {
	constructor() {
		super();

		this.defaultSettings = {
			updateOnWindowResize: true,
			watchOverflow: true
		};

		this.onBreakpointEnable = this.onBreakpointEnable.bind(this);
	}

	connectedCallback() {
		this.breakpoint = this.dataset.breakpoint;

		if (!this.breakpoint) {
			this.createInstance();
			return;
		}

		this.breakpointMediaQuery = window.matchMedia(this.breakpoint);
		this.breakpointMediaQuery.addEventListener('change', this.onBreakpointEnable);
		this.onBreakpointEnable(this.breakpointMediaQuery);
	}

	disconnectedCallback() {
		this.breakpointMediaQuery?.removeEventListener('change', this.onBreakpointEnable);
	}

	createInstance() {
		try {
			const settings = this.dataset.settings;

			this.settingsJSON = settings ? JSON.parse(settings) : {};
			this.swiper = new Swiper(this, Object.assign({}, this.settingsJSON, this.defaultSettings));
		} catch (error) {
			throw new Error(`Failed to create swiper instance: ${this}; Error description: ${error}`);
		}
	}

	/*
	* Example of usage: data-breakpoint="(max-width: 767px)"
	* Swiper only exists while the media query matches.
	* */
	onBreakpointEnable(breakpoint) {
		if (breakpoint.matches) {
			if (!this.swiper || this.swiper.destroyed) this.createInstance();
		} else {
			if (this.swiper && !this.swiper.destroyed) this.swiper.destroy(true, true);
		}
	}
}

if (!customElements.get('swiper-container')) {
	customElements.define('swiper-container', SwiperContainer);
}
